import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const investmentMasterService = createApi({
    reducerPath: 'investmentMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['InvestmentMaster'],
    endpoints: (builder) => ({
        getAllInvestmentMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMasterController.getAllInvestmentMaster}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getInvestmentMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMasterController.getInvestmentMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveInvestmentMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMasterController.saveInvestmentMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateInvestmentMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMasterController.updateInvestmentMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteInvestmentMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMasterController.deleteInvestmentMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllInvestmentMasterBySearch: builder.mutation({
            query(body) {
                console.log(body, "body");

                return {
                    url: `${userManagement.investmentMasterController.getAllInvestmentMasterBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllInvestmentMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMasterController.findAllInvestmentMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveInvestmentMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.investmentMasterController.bulkSaveInvestmentMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});
export const {
    useGetAllInvestmentMasterMutation,
    useGetInvestmentMasterByIdMutation,
    useSaveInvestmentMasterMutation,
    useUpdateInvestmentMasterMutation,
    useDeleteInvestmentMasterMutation,
    useGetAllInvestmentMasterBySearchMutation,
    useFindAllInvestmentMasterMutation,
    useBulkSaveInvestmentMasterMutation,
} = investmentMasterService;